import { useEffect, useRef, useCallback, lazy, Suspense } from "react";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import "@/App.css";
import { Nav } from "@/components/mortlens/Nav";
import { Footer } from "@/components/mortlens/Footer";
import { Hero } from "@/components/mortlens/Hero";

const Why = lazy(() =>
  import("@/components/mortlens/Why").then((m) => ({ default: m.Why })),
);
const Texas = lazy(() =>
  import("@/components/mortlens/TexasSection").then((m) => ({ default: m.Texas })),
);
const How = lazy(() =>
  import("@/components/mortlens/HowFaq").then((m) => ({ default: m.How })),
);
const Faq = lazy(() =>
  import("@/components/mortlens/HowFaq").then((m) => ({ default: m.Faq })),
);
const Waitlist = lazy(() =>
  import("@/components/mortlens/Sections").then((m) => ({ default: m.Waitlist })),
);

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const scrollTo = useCallback((href) => {
    const target = document.querySelector(href);
    if (!target) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: href === "#hero" ? 0 : -64 });
    } else {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="App">
      <Nav onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <Suspense fallback={null}>
          <Why />
          <Texas />
          <How />
          <Faq />
          <Waitlist />
        </Suspense>
      </main>
      <Footer />
      </div>
    </MotionConfig>
  );
}

export default App;
